import type { ICableModel } from "$lib/models/ICableModel";
import { writable } from "svelte/store";

const createTrenchStore = () => {
    const { subscribe, set, update } = writable<ICableModel.TrenchData | undefined>(undefined);
    return {
        update,
        set,
        subscribe,
        reset: () => {
            set(undefined);
        }
    };
}

/**
 * Store for managing a dynamic state of the selected subdivision trench segment.
 * Be aware that this object represents a temporary state, and the truth exists in the entity properties data.
 */
const trenchStateStore = createTrenchStore();

export { trenchStateStore };